import { render } from "./GainApiRuns.vue?vue&type=template&id=8405b27c&scoped=true&ts=true"
import script from "./GainApiRuns.vue?vue&type=script&lang=ts"
export * from "./GainApiRuns.vue?vue&type=script&lang=ts"

import "./GainApiRuns.vue?vue&type=style&index=0&id=8405b27c&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8405b27c"]])

export default __exports__